import { defineComponent, ref, onMounted, onBeforeUnmount } from "vue";
import SvgIcon from "../../../common/base/SvgIcon.vue.mjs";
import ScreenSharingIcon from "../../../common/icons/ScreenSharingIcon.vue.mjs";
import TuiButton from "../../../common/base/Button.vue.mjs";
import Dialog from "../../../common/base/Dialog/index.mjs";
import bus from "../../../../hooks/useMitt.mjs";
import { useI18n } from "../../../../locales/index.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "index",
  setup(__props) {
    const { t } = useI18n();
    const showStopShareRegion = ref(false);
    const localScreenContainerRef = ref();
    const isMiniRegion = ref(false);
    function openStopConfirmDialog() {
      showStopShareRegion.value = true;
    }
    function stopScreenSharing() {
      showStopShareRegion.value = false;
      bus.emit("ScreenShare:stopScreenShare");
    }
    const resizeObserver = new ResizeObserver(() => {
      var _a;
      isMiniRegion.value = ((_a = localScreenContainerRef.value) == null ? void 0 : _a.offsetHeight) <= 200;
    });
    onMounted(() => {
      resizeObserver.observe(localScreenContainerRef.value);
    });
    onBeforeUnmount(() => {
      resizeObserver.unobserve(localScreenContainerRef.value);
    });
    return { __sfc: true, t, showStopShareRegion, localScreenContainerRef, isMiniRegion, openStopConfirmDialog, stopScreenSharing, resizeObserver, SvgIcon, ScreenSharingIcon, TuiButton, Dialog };
  }
});
export {
  _sfc_main as default
};
